import {Component,OnDestroy,OnInit} from '@angular/core';
import {filter,takeUntil} from "rxjs/operators";
import {AppState} from "@domain/appstate";
import {Store} from "@ngrx/store";
import {Subject} from "rxjs";
import {SettingsGlobalState} from "@domain/settings/settings";

/**
 * Composant de dashboard
 */
@Component({
    host: {'data-test-id': 'dashboard'},
    templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit,OnDestroy {
    /** Paramétrage */
    settings: SettingsGlobalState;

    /** Subject de destruction */
    private destroy$ = new Subject<void>();

    /**
     * Constructeur
     */
    constructor(private store: Store<AppState>) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        this.store
            .select(state => state.settings?.['Global'])
            .pipe(
                filter(val => !!val),
                takeUntil(this.destroy$)
            )
            .subscribe(settings => {
                this.settings = settings;
            });
    }

    /**
     * Destructeur
     */
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
